module.exports = __webpack_public_path__ + "images/pages/lp/user_3_0f8d8f494933ac461013fccda0e9cdc7.png";